import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-cnh',
  templateUrl: './text-cnh.component.html',
  styleUrls: ['./text-cnh.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextCnhComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
